<template>
  <div class="rfid-vinculos-item">
    <div v-if="erroModulo" class="ui message warning">
      {{ erroModulo }}
    </div>
    <template v-else>
      <div class="ui segment">
        <h4 class="ui header dividing">Tags RFID ativas</h4>
        <table class="ui celled compact table small">
          <thead>
            <tr>
              <th>EPC</th>
              <th>Usuário</th>
              <th>Vinculado em</th>
              <th class="two wide center aligned">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tag in vinculosAtivos" :key="tag.recnum">
              <td style="word-break: break-all;">{{ tag.epc }}</td>
              <td>{{ tag.usuario }}</td>
              <td>{{ formatarDataHora(tag.created_at) }}</td>
              <td class="center aligned">
                <button
                  type="button"
                  class="ui button orange mini icon"
                  title="Inativar (EPC bloqueado)"
                  @click="confirmarInativar(tag)"
                >
                  <i class="icon ban" />
                </button>
                <button
                  type="button"
                  class="ui button red mini icon"
                  title="Excluir (EPC reutilizável)"
                  @click="confirmarExcluir(tag)"
                >
                  <i class="icon trash" />
                </button>
              </td>
            </tr>
            <tr v-if="!vinculosAtivos.length && !carregando">
              <td colspan="4" class="center aligned">Nenhuma tag ativa</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="ui segment">
        <h4 class="ui header dividing">Histórico (inativas)</h4>
        <table class="ui celled compact table small">
          <thead>
            <tr>
              <th>EPC</th>
              <th>Usuário</th>
              <th>Vinculado em</th>
              <th>Inativada em</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="tag in vinculosHistorico" :key="'h-' + tag.recnum">
              <td style="word-break: break-all;">{{ tag.epc }}</td>
              <td>{{ tag.usuario }}</td>
              <td>{{ formatarDataHora(tag.created_at) }}</td>
              <td>{{ formatarDataHora(tag.inativado_em || tag.updated_at) }}</td>
            </tr>
            <tr v-if="!vinculosHistorico.length && !carregando">
              <td colspan="4" class="center aligned">Nenhuma tag inativa</td>
            </tr>
          </tbody>
        </table>
      </div>

      <button
        type="button"
        class="ui button purple compact icon labeled"
        @click="abrirTelaVinculacao"
      >
        <i class="icon tags" />
        Abrir tela de vinculação RFID
      </button>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import api from '@/services/api';

export default {
  name: 'RfidVinculosItem',
  data() {
    return {
      tipo: 'E',
      local: null,
      equipamento: '',
      produto: '',
      vinculosAtivos: [],
      vinculosHistorico: [],
      carregando: false,
      erroModulo: '',
    };
  },
  created() {
    const q = this.$route.query;
    this.tipo = (q.tipo || 'E').toUpperCase();
    this.local = q.local || null;
    this.equipamento = (q.equipamento || '').trim();
    this.produto = (q.produto || '').trim();
  },
  mounted() {
    this.carregar();
  },
  methods: {
    paramsBase() {
      const params = { tipo: this.tipo };
      if (this.tipo === 'P') {
        params.produto = this.produto;
      } else {
        params.equipamento = this.equipamento;
      }
      return params;
    },
    async carregar() {
      if (this.tipo === 'P' && !this.produto) {
        return;
      }
      if (this.tipo === 'E' && !this.equipamento) {
        return;
      }

      this.carregando = true;
      this.erroModulo = '';
      try {
        const [ativos, historico] = await Promise.all([
          api.get('/api/servicos/rfid-vinculo', { params: this.paramsBase() }),
          api.get('/api/servicos/rfid-vinculo', {
            params: { ...this.paramsBase(), historico: 1 },
          }),
        ]);
        this.vinculosAtivos = ativos.data.data || [];
        this.vinculosHistorico = historico.data.data || [];
      } catch (error) {
        const status = error.response?.status;
        const msg = error.response?.data?.message;
        if (status === 403) {
          this.erroModulo = msg || 'Módulo de expedição não disponível para esta empresa.';
        } else {
          this.$alertify.error(msg || 'Erro ao carregar tags RFID.');
        }
      } finally {
        this.carregando = false;
      }
    },
    formatarDataHora(valor) {
      if (!valor) return '—';
      return moment(valor).format('DD/MM/YYYY HH:mm');
    },
    confirmarInativar(tag) {
      this.$alertify.confirm(
        'Inativar bloqueia o EPC para reutilização. Deseja continuar?',
        async () => {
          try {
            await api.put(`/api/servicos/rfid-vinculo/${tag.recnum}/inativar`);
            this.$alertify.success('Tag inativada.');
            await this.carregar();
          } catch (error) {
            this.$alertify.error(error.response?.data?.message || 'Erro ao inativar tag.');
          }
        },
        () => true,
      );
    },
    confirmarExcluir(tag) {
      this.$alertify.confirm(
        'Excluir remove o vínculo do banco e libera o EPC. Deseja continuar?',
        async () => {
          try {
            await api.delete(`/api/servicos/rfid-vinculo/${tag.recnum}`);
            this.$alertify.success('Vínculo excluído.');
            await this.carregar();
          } catch (error) {
            this.$alertify.error(error.response?.data?.message || 'Erro ao excluir tag.');
          }
        },
        () => true,
      );
    },
    abrirTelaVinculacao() {
      const url = `${window.location.origin}${window.location.pathname}#/estoque/rfid-vinculo`;
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>
.rfid-vinculos-item {
  padding: 8px 12px 16px;
}
</style>
